import {RefundableOptions} from 'protect-group-pulse-react'

export const protectPlusOptions: RefundableOptions = {
	autoQuoteOnProductSelection: true,
	currencyCode: 'GBP',
	environment: 'test',
	eventDateFormat: 'DD/MM/YYYY',
	languageCode: 'en',
	vendorCode: 'ven_local_1c0e76d2510a4974a462321f0e8ae996'
	// vendorCode: 'ven_local_335e49673f04444098836e7c9ba47550'
	// vendorCode: 'ven_live_46ce485311984fc7a9c77942873d781b'
	// vendorCode: 'ven_local_5173fb41a3024425adee91d0c626d7d8'
}

export const options: RefundableOptions = {
	// containerSize: 'small',
	currencyCode: 'USD',
	displayCurrencyCode: 'GBP',
	environment: 'test',
	eventDateFormat: 'DD/MM/YYYY',
	languageCode: 'en',
	// salesTax: 20
	useSaleAction: false,
	// vendorCode: 'ABCROA-AA1D-E62E',
	vendorCode: 'EVENT-PROTECT',
}

export const sessionKeys = {
	quoteData: 'test-app:quote-data',
	eventArgs: 'test-app:event-args',
	bookingReference: 'test-app:booking-reference'
}

export const ticketonTest: RefundableOptions = {
	currencyCode: 'mxn',
	environment: 'test',
	eventDateFormat: 'DD/MM/YYYY',
	languageCode: 'en',
	vendorCode: 'ven_local_eb87d7b463ac449989296aae85db9788'
}
